module.exports = __webpack_public_path__ + "static/media/Trees.e353a907.svg";